import { MatPaginatorIntl } from '@angular/material';

export function CustomPaginator() {
  const customPaginatorIntl = new MatPaginatorIntl();

  customPaginatorIntl.itemsPerPageLabel = 'Elementos por página :';

  const getRangeLabel: (page: number, pageSize: number, length: number) => string = (
    page: number,
    pageSize: number,
    length: number
  ): string => {
    return new MatPaginatorIntl().getRangeLabel(page, pageSize, length).replace(/[a-z]+/i, 'de');
  };
  customPaginatorIntl.getRangeLabel = getRangeLabel;



  return customPaginatorIntl;
}
